module.exports = __webpack_public_path__ + "img/wide-card-btn.d7d8520b.svg";